export const list = (el) => {
    return{
        type: el.type,
        data: {
          data: el.data
        }
      };
}